/* iceberg-ui */
import { PieChart } from '@auviknetworks/iceberg-ui';

/* MUI */
import { Grid, TableCell } from '@mui/material';

/* Shared */
import { popoverContentsColumns } from 'application/Shared/Components/Recharts/PopoverContents';
import { ManagedTable } from 'application/Shared/Components/Table';

/* React */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const Overview = ({ renderingScheduledReport, reportData }) => {
    const { t } = useTranslation();

    const data = reportData.data.map((row) => ({
        name: t(`Deployment.status.${row.name}`),
        value: row.value
    }));

    return (
        <Grid item xs={12} style={{ height: '250px' }}>
            <PieChart
                data={data}
                emptyMessage={t('Common.noData')}
                isAnimationActive={!renderingScheduledReport}
                popoverContentsColumns={popoverContentsColumns}
                responsiveContainerHeight={250}
            />
        </Grid>
    );
};

const headers = (t) => [
    {
        align: 'left',
        field: 'riubCategory',
        renderHeader: <strong>{t('Common.client')}</strong>,
        width: '50%'
    },
    {
        align: 'left',
        field: 'riubUsers',
        renderHeader: <strong>{t('Common.deployment_stage')}</strong>,
        width: '50%'
    }
];

const OverviewBreakdown = ({ renderingScheduledReport, reportData }) => {
    const { t } = useTranslation();
    const rows = reportData.data;

    const csvFields = [
        { key: 'name', label: t('Common.client') },
        { key: 'value', label: t('Common.deployment_stage') }
    ];

    const tableHeaders = useMemo(() => headers(t), [t]);

    return (
        <Grid item lg={12} xs={12} style={{ height: '400px' }}>
            <ManagedTable
                csvExport
                csvExportFields={csvFields}
                csvExportFileName="clientDeploymentStage"
                headers={tableHeaders}
                renderBody={(row) => (
                    <>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>
                            {t(`Deployment.status.${row.value}`)}
                        </TableCell>
                    </>
                )}
                renderBodyKey={null}
                renderFooter={!renderingScheduledReport}
                rows={rows}
                rowsPerPage={10}
                searchEnabled={false}
                sortDirection="DESC"
                sortFieldType="number"
                sortKey="applicationCount"
            />
        </Grid>
    );
};

export const PartnerClientDeploymentStageReports = ({
    renderingScheduledReport,
    reportData
}) => {
    if (typeof reportData === 'undefined') {
        return null;
    }

    return (
        <>
            {reportData.partnerClientDeploymentStageClientStagesBreakdown && (
                <Overview
                    renderingScheduledReport={renderingScheduledReport}
                    reportData={
                        reportData.partnerClientDeploymentStageClientStagesBreakdown
                    }
                />
            )}
            {reportData.partnerClientDeploymentStageClientStagesOverviewBreakdown && (
                <OverviewBreakdown
                    renderingScheduledReport={renderingScheduledReport}
                    reportData={
                        reportData.partnerClientDeploymentStageClientStagesOverviewBreakdown
                    }
                />
            )}
        </>
    );
};
